import cx from 'classnames';
import cn from './InvisibleText.css.json';
import './InvisibleText.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const InvisibleText = props => {
  const {
    children,
    srOnly,
    testId,
    ...spanProps
  } = props;
  return /*#__PURE__*/_jsx("span", {
    "data-testid": testId,
    hidden: !srOnly,
    ...spanProps,
    className: cx(srOnly && cn.srOnly, spanProps.className),
    children: children
  });
};
//# sourceMappingURL=InvisibleText.js.map